import { Box, Button, CircularProgress, Typography } from '@mui/material'

// Modern Loading State
 const PdfLoadingView = ({ text }: { text: string }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '480px',
      py: 8,
      px: 3,
      borderRadius: 3,
      bgcolor: 'background.paper',
      border: '1px dashed',
      borderColor: 'divider',
      mx: 'auto',
      maxWidth: 640,
    }}
  >
    <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2.5 }}>
      <CircularProgress size={54} thickness={3.5} color="primary" />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <i className="fa-regular fa-file-pdf text-primary" style={{ fontSize: 20 }} />
      </Box>
    </Box>
    <Typography variant="subtitle1" fontWeight={600} color="text.primary">
      {text}
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
      Preparing Form 433-B pages & field bindings...
    </Typography>
  </Box>
)


export default PdfLoadingView